<template>
  <div class="Bgc-white">
    <Header/>
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row">
          <div class="col-12 mb-3">
            <p class="title">{{$t('language.posadasCorporate.informacionAdicional.infoCorporate')}}</p>
            <p>
              {{$t('language.posadasCorporate.informacionAdicional.text1')}}
            </p>
          </div>

          <b-card-group class="card-groud-custom">
            <b-card>
              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op1 == 1) ? op1 = 100 : op1 = 1"
                        v-b-toggle.beneficioGeneral>
                        {{$t('language.posadasCorporate.informacionAdicional.beneficiosCorporate')}}
                        <i class="navi link icon-custom-size" :class="(op1 == 1) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="beneficioGeneral">
                      <div class="row">
                        <div class="col-12">
                          <ul class="list-none">
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList1')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList2')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList3')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList4')}}</li>
                          </ul>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>

              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op2 == 2) ? op2 = 200 : op2 = 2"
                        v-b-toggle.beneficioCredito>
                        {{$t('language.posadasCorporate.informacionAdicional.beneficiosEmpCredito')}}
                        <i class="navi link icon-custom-size" :class="(op2 == 2) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="beneficioCredito">
                      <div class="row">
                        <div class="col-12">
                          <ul class="list-none">
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList5')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList6')}}</li>
                          </ul>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>

              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op3 == 3) ? op3 = 300 : op3 = 3"
                        v-b-toggle.ayudaLinea>
                        {{$t('language.posadasCorporate.informacionAdicional.ayudaLineaChat')}}
                        <i class="navi link icon-custom-size" :class="(op3 == 3) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="ayudaLinea">
                      <div class="row">
                        <div class="col-12">
                          <ul class="list-none">
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList7')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList8')}}</li>
                          </ul>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>

              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op4 == 4) ? op4 = 400 : op4 = 4"
                        v-b-toggle.soporteCorpo>
                        {{$t('language.posadasCorporate.informacionAdicional.soporteCorporate')}}
                        <i class="navi link icon-custom-size" :class="(op4 == 4) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="soporteCorpo">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            {{$t('language.posadasCorporate.informacionAdicional.textList9')}}: <a class="f-w-500" :href="'mailto:' + $t('language.posadasCorporate.informacionAdicional.textList9Email')">{{$t('language.posadasCorporate.informacionAdicional.textList9Email')}}</a>
                          </p>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>

              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op5 == 5) ? op5 = 500 : op5 = 5"
                        v-b-toggle.accesoTarifas>
                        {{$t('language.posadasCorporate.informacionAdicional.accesoTarifasNegPub')}}
                        <i class="navi link icon-custom-size" :class="(op5 == 5) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="accesoTarifas">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            {{$t('language.posadasCorporate.informacionAdicional.textList10')}}:
                          </p>
                          <ul class="list-none">
                            <li class="mb-4"><span class="f-w-500">· {{$t('language.posadasCorporate.informacionAdicional.textList11')}}</span> <br>
                              &nbsp; {{$t('language.posadasCorporate.informacionAdicional.textList12')}}</li>

                            <li class="mb-4"><span class="f-w-500">· {{$t('language.posadasCorporate.informacionAdicional.textList13')}}</span><br>
                              &nbsp; {{$t('language.posadasCorporate.informacionAdicional.textList14')}}</li>

                            <li class="mb-4"><span class="f-w-500">· {{$t('language.posadasCorporate.informacionAdicional.textList15')}}</span><br>
                                &nbsp; {{$t('language.posadasCorporate.informacionAdicional.textList16')}}</li>
                            <li class="mb-4"><span class="f-w-500">· {{$t('language.posadasCorporate.informacionAdicional.textList17')}} </span><br>
                              &nbsp; {{$t('language.posadasCorporate.informacionAdicional.textList18')}}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>

              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op6 == 6) ? op6 = 600 : op6 = 6"
                        v-b-toggle.reservacionesMulti>
                        {{$t('language.posadasCorporate.informacionAdicional.reservacionesMultiples')}}
                        <i class="navi link icon-custom-size" :class="(op6 == 6) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="reservacionesMulti">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            {{$t('language.posadasCorporate.informacionAdicional.textList19')}}:
                          </p>
                          <ul class="list-none">
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList20')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList21')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList22')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList23')}}</li>
                          </ul>
                          <p>{{$t('language.posadasCorporate.informacionAdicional.textList24')}}</p>
                          <p>{{$t('language.posadasCorporate.informacionAdicional.textList25')}} <a class="f-w-500" :href="'tel:' + $t('language.posadasCorporate.informacionAdicional.textList25Tel')">{{$t('language.posadasCorporate.informacionAdicional.textList25Tel')}}</a> {{$t('language.posadasCorporate.informacionAdicional.textList25Comp')}} <a class="f-w-500" :href="'mailto:' + $t('language.posadasCorporate.informacionAdicional.textList25Email')">{{$t('language.posadasCorporate.informacionAdicional.textList25Email')}}</a>.</p>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>

              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op7 == 7) ? op7 = 700 : op7 = 7"
                        v-b-toggle.activacionProfo>
                        {{$t('language.posadasCorporate.informacionAdicional.activacionProforma')}}
                        <i class="navi link icon-custom-size" :class="(op7 == 7) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="activacionProfo">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            {{$t('language.posadasCorporate.informacionAdicional.textList26')}}
                          </p>
                          <p>{{$t('language.posadasCorporate.informacionAdicional.textList27')}}</p>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>

              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op8 == 8) ? op8 = 800 : op8 = 8"
                        v-b-toggle.consideraciones>
                        {{$t('language.posadasCorporate.informacionAdicional.consideracionesAdicionales')}}
                        <i class="navi link icon-custom-size" :class="(op8 == 8) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="consideraciones">
                      <div class="row">
                        <div class="col-12">
                          <ul class="list-none">
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList28')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList29')}}</li>
                            <li>· {{$t('language.posadasCorporate.informacionAdicional.textList30')}}</li>
                          </ul>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>

              <b-collapse visible class="row">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-12">
                      <p class="subtitle" @click="(op9 == 9) ? op9 = 900 : op9 = 9"
                        v-b-toggle.seguridadInfor>
                        {{$t('language.posadasCorporate.informacionAdicional.seguridadInfoCorporate')}}
                        <i class="navi link icon-custom-size" :class="(op9 == 9) ? 'camposActive icon-up' : 'icon-navigate-down'"></i>
                      </p>
                    </div>
                    <b-collapse class="col-12" id="seguridadInfor">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            {{$t('language.posadasCorporate.informacionAdicional.textList31')}}
                          </p>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <hr>
                </div>
              </b-collapse>
            </b-card>
          </b-card-group>

          <div class="col-12 col-md-4 mt-2 mb-5 ml-auto">
            <router-link to="/informacion-corporate" tag="button" class="mt-3 secondary-button">
              {{$t('language.posadasCorporate.informacionAdicional.regresar')}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  export default {
    name: 'Contacto',
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        op1: null,
        op2: null,
        op3: null,
        op4: null,
        op5: null,
        op6: null,
        op7: null,
        op8: null,
        op9: null,
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';
  .card-groud-custom {
    width: 100%;
    .card {
      border: none;
      .subtitle {
        justify-content: space-between;
        display: flex;
        margin: 0;
      }
    }
  }
  ul {
    li {
      font-size: 14px;
    }
  }
  .icon-custom-size {
    font-size: 24px;
  }
</style>